import { Component, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FieldConfig } from '../../../interfaces/field.interface';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-checkbox',
  template: `
    <ion-item class="switcher-item" [formGroup]="group">
      <ion-toggle
        [enableOnOffLabels]="true"
        class="bold-1"
        [formControlName]="field.name"
      >
        <p>{{ field.label ? (field.label | translate) : '' }}</p>
      </ion-toggle>
    </ion-item>
  `,
  styles: [
    `
      .switcher-item {
        padding: 10px 0;
        --inner-border-width: 0;
        margin: 0 20px;

        .bold-1 {
          font-size: 14px;
        }
      }
      p {
        font-weight: 500;
      }

      ion-toggle::part(label) {
        white-space: normal !important;
      }
    `,
  ],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule, ReactiveFormsModule],
})
export class CheckboxComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;

  constructor() {}
  ngOnInit() {}
}
